module.exports = __webpack_public_path__ + "assets/img/d420671ae5aea359bb7299094139db5f.svg";